import { useEffect, useState } from 'react';
import { getSettings } from '@/services/settings.service';

export function useSiteSettings(){
 const [settings,setSettings]=useState(null);
 useEffect(()=>{
  getSettings().then(r=>setSettings(r?.data || r)).catch(()=>{});
 },[]);
 return settings;
}
